import React from "react";
import styles from "./feed.module.scss";

export default function FeedSkeletonCard() {
  return (
    <div className={styles.skeletonCard}>
      <div className={styles.skeletonHeader}>
        <div className={styles.skeletonAvatar} />
        <div className={styles.skeletonHeaderInfo}>
          <div className={styles.skeletonLineShort} />
          <div className={styles.skeletonLineTiny} />
        </div>
      </div>

      <div className={styles.skeletonBody}>
        <div className={styles.skeletonLine} />
        <div className={styles.skeletonLine} />
        <div className={styles.skeletonLineShort} />
      </div>

      <div className={styles.skeletonImage} />

      <div className={styles.skeletonActions}>
        <div className={styles.skeletonAction} />
        <div className={styles.skeletonAction} />
        <div className={styles.skeletonAction} />
      </div>
    </div>
  );
}
